import React from "react";
import { useNavigate } from "react-router-dom";
import { useApi, fetchTeam } from "../api";
import { useAuth } from "../context/AuthContext";
import { Loading, ErrorState } from "../components/common";
import { LogIn } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { data: team, loading, error, reload } = useApi(fetchTeam);

  const pick = (m) => {
    login({ id: m.id, name: m.name, role: m.role, email: m.email, initials: m.initials, color: m.color });
    navigate("/");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#1c1e26] px-4 py-10">
      <div className="w-full max-w-3xl">
        <div className="mb-8 flex flex-col items-center text-center">
          <img
            src="https://images.squarespace-cdn.com/content/v1/60bf46855b35197d90ad4d6a/2fe6a5e1-3577-4344-a25f-eb0a17310d8b/EPG50+-+landscape+over+red+background%404x.png?format=1500w"
            alt="EP Group"
            className="h-10 w-auto"
          />
          <h1 className="mt-6 text-2xl font-bold text-white">Project Management System</h1>
          <p className="mt-1 text-sm text-slate-400">Select your profile to sign in · <span className="font-semibold italic text-[#5b8def]">Primark</span> programme</p>
        </div>

        {error ? (
          <div className="rounded-2xl bg-white p-6"><ErrorState message={error} onRetry={reload} /></div>
        ) : loading || !team ? (
          <div className="rounded-2xl bg-white p-6"><Loading /></div>
        ) : (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {team.map((m) => (
              <button key={m.id} onClick={() => pick(m)}
                className="group flex items-center gap-3 rounded-xl border border-white/10 bg-[#282b36] p-4 text-left transition-all hover:border-[#d0333a] hover:bg-[#2f3340]">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white" style={{ backgroundColor: m.color }}>{m.initials}</div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-white">{m.name}</p>
                  <p className="truncate text-xs text-slate-400">{m.role || "Team Member"}</p>
                </div>
                <LogIn className="h-4 w-4 text-slate-500 transition-colors group-hover:text-[#d0333a]" />
              </button>
            ))}
          </div>
        )}
        <p className="mt-8 text-center text-xs text-slate-500">Demo sign-in — no password required. Each profile sees their own projects, tasks &amp; notifications.</p>
      </div>
    </div>
  );
}
